import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./OpalUnitSelectorModal.css";
import { getAll } from "../../../../../localDB";
import TauriLoader2 from "../../../../TauriLoader2/TauriLoader2";

const OpalUnitSelectorModal = ({ show, onHide, onSelect }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const units = await getAll('unit');
            setData(units);
        } catch (error) {
            console.log('error fetching units.')
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    const filteredData = data.filter((item) =>
        item?.Code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.Description?.toLowerCase().includes(searchTerm?.toLowerCase())
    );

    const handleRowSelect = (item) => {
        onSelect?.(item); 
        onHide?.();        
    };

    return (
        <Modal className="opal-unitlist-modal" show={show} onHide={onHide} centered>
            <Modal.Header>
                <div className="modal-header-content">
                    <div className="modal-title">Units</div>
                    <div className="input-group search-input">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                {isLoading ?
                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                    :
                    <table className="units-table">
                        <thead className="units-table-header">
                            <tr>
                                <th>Code</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody className="units-table-body">
                            {filteredData.map((item) => (
                                <tr key={item?.ID} onClick={() => handleRowSelect(item)} className="clickable">
                                    <td>{item?.Code}</td>
                                    <td>{item?.Description}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
};

export default OpalUnitSelectorModal;